import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import {
    LineChart, Line, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import moment from 'moment';

const generateData = (name, values) => {
    let result = [];
    for(const index in values) {
        result.push({
            balance: values[index].toFixed(2),
            date: moment(new Date()).subtract(index, 'day')
        })
    }
    return values ? result : [];
}

const AssetHistoryChart = ({ t, name, values, color}) => (
    <Col xs={12} md={12} lg={12} xl={12}>
        <Card>
            <CardBody>
                <div className="card__title">
                    <h5 className="bold-text">{name} history</h5>
                </div>
                <ResponsiveContainer height={150}>
                    <LineChart
                        data={generateData(name, values)}
                        margin={{ top: 0, right: 0, left: -15, bottom: 0}}
                    >
                        <YAxis />
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip payload={[{ name: '05-01', value: 12, unit: 'kg' }]}/>
                        <Line type="monotone" dataKey="balance" stroke={ color || "#4ce1b6"} dot={{r: 0}} activeDot={{ r: 4 }} />
                    </LineChart>
                </ResponsiveContainer>
            </CardBody>
        </Card>
    </Col>
);

AssetHistoryChart.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(AssetHistoryChart);
